import { render, staticRenderFns } from "./ball-joint.vue?vue&type=template&id=0340a172&scoped=true&"
import script from "./ball-joint.js?vue&type=script&lang=js&"
export * from "./ball-joint.js?vue&type=script&lang=js&"
import style0 from "./ball-joint.vue?vue&type=style&index=0&id=0340a172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0340a172",
  null
  
)

export default component.exports